const HEADER_MOD = {
        "Do you have a simple, streamlined agent desktop with the digital tools needed to service today’s modern customers?": {
        header: "Agent Experience",
        negCopy:"Give agents a single, unified desktop to help them manage customer interactions across channels, increase efficiency, and improve the customer experience.",
        negLink:"",
        negLinkTxt:"",    
    }
}
export default HEADER_MOD;